import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip';
import { isExtensionContext } from '@common-services/detect-context';

interface CampaignInternalHeaderProps {
    title: string;
    onBackClick: () => void;
    isMessagesPlanner?: boolean;
    backTooltip?: string;
}

export default function CampaignInternalHeader({ title, onBackClick, isMessagesPlanner = false, backTooltip = 'Back to WhatsApp' }: CampaignInternalHeaderProps) {
    const isExtension = isExtensionContext();

    // In extension context (not Messages Planner), use fixed positioning for back button overlay
    // In website context, always show as a normal header
    const useFixedPositioning = isExtension && !isMessagesPlanner;

    return (
        <div
            className="flex items-center gap-4 px-6 border-b border-border bg-white dark:bg-slate-900"
            style={useFixedPositioning ? {
                width: '100%',
                minHeight: '81px',
                borderBottom: 'none',
                position: 'fixed',
                top: '0',
                left: '0',
                right: '0',
                zIndex: '1000',
                backgroundColor: 'unset',
                pointerEvents: 'none',
            } : {
                width: '100%',
                minHeight: '64px',
                borderBottom: '1px solid var(--color-border)',
                backgroundColor: 'var(--page-header-bg, #fff)',
            }}
        >
            {/* Back Button — title shown as tooltip on hover to save space */}
            <Tooltip>
                <TooltipTrigger asChild>
                    <button
                        onClick={onBackClick}
                        aria-label={title}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            padding: '8px',
                            background: 'transparent',
                            border: '1px solid var(--color-border, #e5e7eb)',
                            borderRadius: '8px',
                            cursor: 'pointer',
                            color: 'var(--color-primary)',
                            transition: 'all 0.2s',
                            pointerEvents: 'auto',
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.background = 'var(--color-hover, #f3f4f6)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.background = 'transparent';
                        }}
                    >
                        <ArrowLeft size={20} />
                    </button>
                </TooltipTrigger>
                <TooltipContent side="bottom">{backTooltip}</TooltipContent>
            </Tooltip>
        </div>
    );
}
